import { PayloadAction } from '@reduxjs/toolkit';
import { mountingPartActions } from '.';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  selectCustomerNumber,
  selectErpSystem,
  selectLanguageId,
} from 'app/features/erpSystem/slice/selectors';
import { erpalPayloadDTO } from 'app/features/price/slice/utils';
import { transformMountingPart } from './utils';
import { mountingPartActions as actions } from '.';
import { selectStoreId } from 'app/features/salesOrganisation/slice/selectors';
function* setMountingPart(action: PayloadAction<any>) {
  const mountingPart = action.payload;
  const { setMountingPartSuccess, setMountingPartFailure } =
    mountingPartActions;

  try {
    const customerNumber = yield select(selectCustomerNumber);
    const languageId = yield select(selectLanguageId);
    const erpSystem = yield select(selectErpSystem);
    const storeId = yield select(selectStoreId);

    const requestPayload = yield erpalPayloadDTO([action.payload]);
    const shopId = storeId % 10; // Get last digit of store id Ex: 100001  => 1

    const priceResponse = yield call(
      fetch,
      `/valve-configurator/api/price?customerNumber=${customerNumber}&shopId=${shopId}&currency=EUR&languageId=${languageId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload),
      },
    );
    const mountingPartPrice = yield priceResponse.json();

    const stockResponse = yield call(
      fetch,
      `/valve-configurator/api/stockStatus?erpSystem=${erpSystem}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload),
      },
    );
    const mountingPartStock = yield stockResponse.json();

    return yield put(
      setMountingPartSuccess(
        transformMountingPart(
          mountingPart,
          mountingPartPrice.items,
          mountingPartStock.items,
        ),
      ),
    );
  } catch (e) {
    yield put(setMountingPartFailure(e));
  }
}

export function* mountingPartSaga() {
  yield takeLatest(actions.setMountingPart.type, setMountingPart);
}
